module.exports = __webpack_public_path__ + "img/qbsb8.b239fd4a.png";